/* import __COLOCATED_TEMPLATE__ from './sq-input-select.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { classNames } from '@ember-decorators/component';
/**
## Input Select
`sq-input-select` is a super old `<select>` component that is now borderline deprecated. All it does is render an `sq-field-select` using
the Bridgeport-era hella old form styles. You probably should just use `sq-field-select` directly, and pass it `includeBaseStyling=false`
if for some reason you don't want the "field" styling.

See `sq-field-select` for accepted parameters, since all this does is pass the exact sme params down.
 */

import Component from '@ember/component';
let SqInputSelect = (_dec = classNames('sq-input-select'), _dec(_class = class SqInputSelect extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "optionValuePath", 'value');
    _defineProperty(this, "optionLabelPath", 'label');
    _defineProperty(this, "optionDisabledPath", 'disabled');
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "useOptionsAsValues", false);
    _defineProperty(this, "enablePromptSelection", false);
    _defineProperty(this, "value", null);
    _defineProperty(this, "isInvalid", false);
  }
}) || _class);
export { SqInputSelect as default };